import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { ShopOrdersExport } = protos;

/**
 * Fetch a report of shop orders in a csv file
 */
export function downloadShopOrdersCsv(search: unknown): ApiAction {
  return {
    TockApi: {
      postProtoForFile: '/reports/shop-orders',
      type: AppConstants.SHOP_ORDERS_DOWNLOAD_CSV,
      request: ShopOrdersExport.fromObject({
        search,
        // First arg needs to be removed in the back-end
        first: 10000,
      }),
    },
  };
}
